// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3MJvC","grid":"grid__2r7WQ","heart":"heart__2BtKU","sparkle":"sparkle__1Ncr5"};


//////////////////
// WEBPACK FOOTER
// ./components/LoveHeart/style.css
// module id = 52fv
// module chunks = 0